import React from 'react';

import styles from './Hero.module.scss';

const Hero = (props) => (
  <div className={styles.Hero} style={{backgroundImage: 'url("' + props.backgroundImage.file.url + '")'}}>
    <h1>{props.title}</h1>
    <p>{props.text}</p>
  </div>
)

export default Hero;



// WEBPACK FOOTER //
// ./src/components/DayInTheLife/Hero/index.js